module.exports = __webpack_public_path__ + "static/1-9e3fd643514b077d4b9c2540630b9aaa.jpg";